export default "__VITE_ASSET__Bj2uT3A5__"